export const FLYOUT_PORTAL = 'flyout-portal-host';
